<script setup lang="ts">
import { NotSellableProps } from "./NotSellable.props"

const { productCode } = defineProps<NotSellableProps>()

const emit =
  defineEmits<{
    (e: "handleScrollToAlternatives"): void
  }>()

const handleScrollToAlternatives = async () => {
  emit("handleScrollToAlternatives")
}
</script>

<template>
  <div
    class="
      not-sellable-purchase-type-wrapper
      bg-grey-main
      flex flex-col
      gap-4
      rounded-lg
      p-4
    "
  >
    <p class="dolphin-bold mb-0 flex w-full items-center">
      <UtilsIcon
        name="Warning.svg"
        class="mr-2 inline-block h-6 w-6"
        fetch-priority="high"
        :preload="true"
      />
      <UtilsMarkdown
        :content="$t('productPage.purchaseType.notSellable.title')"
        tag="span"
        class="beaver-bold md:pig"
      />
    </p>

    <UtilsMarkdown
      class="beaver markdown__strong-beaver-bold w-full"
      :key="'notSellableText'"
      :content="$t('productPage.purchaseType.notSellable.subtitle_1')"
    />

    <UtilsMarkdown
      class="beaver markdown__strong-beaver-bold w-full"
      :key="'notSellableText'"
      :content="$t('productPage.purchaseType.notSellable.subtitle_2')"
    />

    <UtilsButton
      type="submit"
      class="w-full"
      :text="$t('productPage.purchaseType.notSellable.similarProduct')"
      @click="handleScrollToAlternatives"
    />
  </div>
</template>
